import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Compass, FileText, Users, LayoutDashboard } from 'lucide-react';

export function QuickLinksCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const links = [
    { label: t('myProfile.quickLinks.opportunities'), icon: Compass, path: '/opportunities' },
    { label: t('myProfile.quickLinks.applications'), icon: FileText, path: '/applications' },
    { label: t('myProfile.quickLinks.talent'), icon: Users, path: '/talent' },
    { label: t('myProfile.quickLinks.dashboard'), icon: LayoutDashboard, path: '/dashboard/professional' },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Compass className="h-5 w-5 text-primary" />
          {t('myProfile.quickLinks.title')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {links.map(l => (
            <Button key={l.path} variant="outline" className="flex-col h-auto py-4 gap-2" onClick={() => navigate(l.path)}>
              <l.icon className="h-5 w-5 text-primary" />
              <span className="text-xs">{l.label}</span>
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
